window.constraints_complaints = {
    phone: {
        format: {
            pattern: /^[\d]{10,10}$/,
            flags: "i",
            message: "^Ingrese un número de teléfono a 10 dígitos."
        }
    }
};
